<!-- 定制商品表格组件 -->
<template>
  <div>
    <div class="mb16">
      <a-button type="primary" @click="handleAdd" icon="plus" class="mt10">
        添加定制商品
      </a-button>
    </div>

    <a-table
      rowKey="id"
      :columns="columns"
      :data-source="goodsList"
      bordered
      :pagination="false"
    >
      <a-space slot="img" slot-scope="item, row">
        <a-avatar shape="square" :size="44" :src="IMGHOST + row.img" />
      </a-space>

      <a-space slot="price" slot-scope="item, row">
        <span>¥{{ $common.toDecimal2(row.price / 100) }}</span>
      </a-space>

      <a-space slot="pre_discount_price" slot-scope="item, row">
        <span
          >¥{{ $common.toDecimal2((row.pre_discount_price || 0) / 100) }}</span
        >
      </a-space>

      <a-space slot="is_delivery" slot-scope="item, row">
        <span>{{ row.is_delivery == 1 ? "已发货" : "未发货" }}</span>
      </a-space>

      <a-space slot="after_sale_status" slot-scope="item, row">
        <span>{{ row.after_sale_status == 1 ? "售后中" : "-" }}</span>
      </a-space>

      <a-space slot="goods_name" slot-scope="item, row">
        <span>
          <span
            v-if="
              getLimitCouponGoodsIds &&
              getLimitCouponGoodsIds.includes(row.goods_id)
            "
            style="color: red; margin-right: 4px"
          >
            限时
          </span>
          {{ row.goods_name }}
        </span>
      </a-space>

      <a-space slot="action" slot-scope="item, row">
        <a-button size="small" type="primary" @click="handleEdit(row)">
          编辑
        </a-button>
        <a-popconfirm
          title="确定要删除这个商品吗？"
          ok-text="确定"
          cancel-text="取消"
          @confirm="handleDelete(row)"
        >
          <a-button size="small" type="danger"> 删除 </a-button>
        </a-popconfirm>
      </a-space>
    </a-table>

    <!-- 添加/编辑商品模态框 -->
    <a-modal
      :title="modalTitle"
      :visible="modalVisible"
      :confirm-loading="confirmLoading"
      @ok="handleModalOk"
      @cancel="handleModalCancel"
      width="600px"
    >
      <a-form-model
        ref="formRef"
        :model="formData"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="商品名称" prop="goods_name">
          <a-auto-complete
            v-model="goodsInputValue"
            placeholder="请搜索商品名称"
            :data-source="goodsDataSource"
            @search="handleGoodsSearch"
            @select="handleGoodsSelect"
            @change="handleGoodsInputChange"
            style="width: 100%"
            allow-clear
          />
        </a-form-model-item>

        <a-form-model-item label="规格" prop="goods_spec_desc">
          <a-auto-complete
            v-model="specInputValue"
            placeholder="请选择规格或自定义输入"
            :data-source="specDataSource"
            @change="handleSpecInputChange"
            @select="handleSpecSelect"
            style="width: 100%"
            allow-clear
          />
        </a-form-model-item>

        <a-form-model-item label="品牌" prop="brand_id">
          <a-select
            v-model="formData.brand_id"
            placeholder="请选择品牌"
            style="width: 100%"
          >
            <a-select-option
              v-for="brand in brandData"
              :key="brand.id"
              :value="brand.id"
            >
              {{ brand.brand_name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="商品图片" prop="img">
          <div class="fs12 color666">建议上传尺寸：750*750</div>
          <imgUpload
            v-if="modalVisible"
            :key="uploadKey"
            @remove="removeUpload"
            @result="resultUpload"
            :list="formData.img ? [formData.img] : []"
            :maxLength="1"
            :type="'img'"
          />
        </a-form-model-item>

        <a-form-model-item label="购买数量" prop="num">
          <a-input-number
            v-model="formData.num"
            :min="1"
            placeholder="请输入数量"
            style="width: 100%"
          />
        </a-form-model-item>

        <a-form-model-item label="成交价" prop="price">
          <a-input-number
            v-model="formData.price"
            :min="0"
            placeholder="请输入价格"
            style="width: 100%"
          />
        </a-form-model-item>

        <a-form-model-item label="后台标价" prop="pre_discount_price">
          <a-input-number
            v-model="formData.pre_discount_price"
            :min="0"
            placeholder="请输入后台标价"
            style="width: 100%"
          />
        </a-form-model-item>

        <a-form-model-item label="商品总价">
          <span style="color: #1890ff; font-weight: bold">
            ¥{{ $common.toDecimal2(totalGoodsAmount / 100) }}
          </span>
        </a-form-model-item>

        <a-form-model-item label="可用定制单金额">
          <span
            :style="{
              color: availableCustomAmount >= 0 ? '#52c41a' : '#ff4d4f',
              fontWeight: 'bold',
            }"
          >
            ¥{{ $common.toDecimal2(availableCustomAmount / 100) }}
          </span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  goodsSpecIndex,
  customGoodsSave,
  delCustomGoods,
  searchGoods,
  goodsSpec,
} from "@/api/orders";
import imgUpload from "@/components/myUpload.vue";

export default {
  name: "CustomizedGoodsTable",
  components: {
    imgUpload,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    getLimitCouponGoodsIds: {
      type: Array,
      default: () => [],
    },
    orderSn: {
      type: String,
      default: "",
    },
    brandData: {
      type: Array,
      default: () => [],
    },
    goodsAmount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      IMGHOST: window.IMGHOST,
      goodsList: this.value ? [...this.value] : [],
      modalVisible: false,
      confirmLoading: false,
      editingItem: null,
      isInternalUpdate: false,
      formData: {
        goods_spec_id: undefined,
        goods_id: 0,
        goods_name: "",
        brand_id: undefined,
        img: "",
        num: 1,
        price: 0,
        pre_discount_price: 0,
        goods_spec_desc: "",
        is_delivery: 0,
        after_sale_status: 0,
        orders_items_id: null,
      },
      uploadKey: 0,
      goodsInputValue: "", // 商品名称输入值
      goodsDataSource: [], // 商品名称数据源
      goodsOptions: [], // 商品搜索原始数据
      goodsSearchLoading: false,
      searchTimeout: null,
      selectedGoods: null,
      goodsSpecs: [], // 商品规格列表
      selectedSpecId: undefined, // 选中的规格ID
      specInputValue: "", // 规格输入值
      specDataSource: [], // 规格数据源
      columns: [
        {
          title: "商品",
          width: 80,
          dataIndex: "img",
          scopedSlots: { customRender: "img" },
        },
        {
          title: "商品名称",
          dataIndex: "goods_name",
          scopedSlots: { customRender: "goods_name" },
        },
        { title: "购买数量", dataIndex: "num" },
        {
          title: "成交价",
          dataIndex: "price",
          scopedSlots: { customRender: "price" },
        },
        {
          title: "后台标价",
          dataIndex: "pre_discount_price",
          scopedSlots: { customRender: "pre_discount_price" },
        },
        { title: "规格描述", dataIndex: "goods_spec_desc" },
        {
          title: "发货状态",
          dataIndex: "is_delivery",
          scopedSlots: { customRender: "is_delivery" },
        },
        {
          title: "售后状态",
          dataIndex: "after_sale_status",
          scopedSlots: { customRender: "after_sale_status" },
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          scopedSlots: { customRender: "action" },
        },
      ],
      rules: {
        goods_name: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
        ],
        num: [{ required: true, message: "请输入购买数量", trigger: "blur" }],
        price: [{ required: true, message: "请输入成交价", trigger: "blur" }],
      },
    };
  },
  computed: {
    modalTitle() {
      return this.editingItem ? "编辑商品" : "添加商品";
    },
    // 计算所有商品的总价
    totalGoodsAmount() {
      let total = 0;

      // 计算列表中已有商品的总价
      this.goodsList.forEach((item) => {
        if (this.editingItem && item.id === this.editingItem.id) {
          // 如果是正在编辑的商品，跳过
          return;
        }
        total += (item.price || 0) * (item.num || 0);
      });

      // 加上当前正在编辑/添加的商品价格
      if (this.formData.price && this.formData.num) {
        total += this.formData.price * 100 * this.formData.num; // formData.price是元，需要转为分
      }

      return Math.floor(Math.round(total));
    },
    availableCustomAmount() {
      return this.goodsAmount - this.totalGoodsAmount;
    },
  },
  watch: {
    value: {
      handler(newVal) {
        if (!this.isInternalUpdate) {
          this.goodsList = newVal ? [...newVal] : [];
        }
      },
      deep: true,
      immediate: true,
    },
    goodsList: {
      handler(newVal) {
        this.isInternalUpdate = true;
        this.$emit("input", newVal);
        this.$emit("change", newVal);
        this.$nextTick(() => {
          this.isInternalUpdate = false;
        });
      },
      deep: true,
    },
  },
  methods: {
    handleAdd() {
      this.editingItem = null;
      this.formData = {
        goods_spec_id: undefined,
        goods_id: 0,
        goods_name: "",
        brand_id: undefined,
        img: "",
        num: 1,
        price: "",
        pre_discount_price: "",
        goods_spec_desc: "",
        is_delivery: "",
        after_sale_status: 0,
        orders_items_id: null,
      };
      this.goodsDataSource = [];
      this.goodsOptions = [];
      this.selectedGoods = null;
      this.goodsSpecs = [];
      this.selectedSpecId = undefined;
      this.goodsInputValue = "";
      this.specInputValue = "";
      this.specDataSource = [];
      this.uploadKey++;
      this.modalVisible = true;
    },

    handleEdit(row) {
      this.editingItem = row;
      this.formData = {
        ...row,
        orders_items_id: row.id,
        price: row.price ? row.price / 100 : 0,
        pre_discount_price: row.pre_discount_price
          ? row.pre_discount_price / 100
          : 0,
      };
      this.goodsDataSource = [];
      this.goodsOptions = [];
      this.selectedGoods = {
        id: row.goods_id,
        goods_name: row.goods_name,
        brand_id: row.brand_id,
      };
      this.goodsInputValue = row.goods_name;
      this.goodsSpecs = [];
      this.selectedSpecId = undefined;
      this.specInputValue = row.goods_spec_desc || "";

      // 如果有商品ID，获取规格列表
      if (row.goods_id) {
        this.fetchGoodsSpecs(row.goods_id);
      }

      this.uploadKey++;
      this.modalVisible = true;
    },

    async handleDelete(row) {
      try {
        await delCustomGoods({ id: row.id });

        const index = this.goodsList.findIndex((item) => item.id === row.id);
        if (index > -1) {
          this.goodsList.splice(index, 1);
        }

        this.$message.success("删除成功");
      } catch (error) {
        console.error("删除失败:", error);
        this.$message.error("删除失败，请重试");
      }
    },

    async handleModalOk() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          // 检查是否超过订单价值
          if (this.availableCustomAmount < 0) {
            this.$message.error("已经超过订单价值了");
            return;
          }

          this.confirmLoading = true;

          try {
            // 提交
            const submitData = {
              order_sn: this.orderSn,
              goods_id: this.formData.goods_id || 0,
              goods_spec_id: this.selectedSpecId || 0,
              goods_name: this.formData.goods_name,
              price: this.formData.price || 0,
              pre_discount_price: this.formData.pre_discount_price || 0,
              brand_id: this.formData.brand_id || 0,
              img: this.formData.img,
              num: this.formData.num,
              goods_spec_desc: this.formData.goods_spec_desc,
            };

            if (this.editingItem && this.formData.orders_items_id) {
              submitData.orders_items_id = this.formData.orders_items_id;
            }

            await customGoodsSave(submitData);

            this.$message.success(this.editingItem ? "编辑成功" : "添加成功");
            this.modalVisible = false;

            this.$emit("refresh");
          } catch (error) {
            console.error("保存失败:", error);
            this.$message.error("保存失败，请重试");
          } finally {
            this.confirmLoading = false;
          }
        }
      });
    },

    handleModalCancel() {
      this.modalVisible = false;
      this.confirmLoading = false;
    },

    // 商品名称搜索
    handleGoodsSearch(keyword) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(() => {
        if (keyword && keyword.trim()) {
          this.searchGoods(keyword.trim());
        } else {
          this.goodsDataSource = [];
          this.goodsOptions = [];
        }
      }, 300);
    },

    // 搜索商品
    async searchGoods(keyword) {
      this.goodsSearchLoading = true;
      try {
        const result = await searchGoods({ keyword });
        // 转换为自动完成数据源格式
        this.goodsOptions = result || []; // 保存原始数据
        this.goodsDataSource = (result || []).map((item) => item.goods_name);
      } catch (error) {
        console.error("搜索商品失败:", error);
        this.$message.error("搜索商品失败");
        this.goodsDataSource = [];
        this.goodsOptions = [];
      } finally {
        this.goodsSearchLoading = false;
      }
    },

    // 选择商品时的处理
    handleGoodsSelect(value, option) {
      // value是选中的商品名称，需要从goodsOptions中找到对应的商品数据
      const selectedGoods = this.goodsOptions.find(
        (item) => item.goods_name === value
      );
      if (selectedGoods) {
        this.selectedGoods = selectedGoods;
        this.formData.goods_id = selectedGoods.id;
        this.formData.goods_name = selectedGoods.goods_name;
        this.formData.brand_id = selectedGoods.brand_id;
        this.goodsInputValue = value;
        this.fetchGoodsSpecs(selectedGoods.id);
      }
    },

    handleGoodsInputChange(value) {
      // 更新表单中的商品名称
      this.formData.goods_name = value || "";

      if (!value) {
        // 输入为空时清空所有数据
        this.selectedGoods = null;
        this.goodsSpecs = [];
        this.selectedSpecId = undefined;
        this.formData.goods_spec_desc = "";
        this.formData.goods_id = 0;
        this.formData.brand_id = undefined;
        this.formData.img = "";
        this.formData.price = "";
        this.formData.pre_discount_price = "";
        this.specInputValue = "";
        this.specDataSource = [];
      } else {
        // 检查输入的值是否在搜索结果中存在
        const isFromSearchResult = this.goodsDataSource.includes(value);

        if (!isFromSearchResult) {
          this.selectedGoods = null;
          this.goodsSpecs = [];
          this.selectedSpecId = undefined;
          this.formData.goods_spec_desc = "";
          this.formData.goods_id = 0;
          this.formData.brand_id = undefined;
          this.formData.img = "";
          this.formData.price = "";
          this.formData.pre_discount_price = "";
          this.specInputValue = "";
          this.specDataSource = [];
        }
      }
    },

    // 根据商品ID获取规格列表
    async fetchGoodsSpecs(goodsId) {
      try {
        const result = await goodsSpec({ goods_id: goodsId });
        this.goodsSpecs = result || [];
        // 将规格转换为自动完成数据源 - 处理重复项
        const descMap = new Map();
        this.specDataSource = this.goodsSpecs
          .map((spec) => {
            const desc = spec.desc || "";
            if (desc.trim() === "") return null;

            // 如果描述重复，加上序号区分
            const count = descMap.get(desc) || 0;
            descMap.set(desc, count + 1);

            return count > 0 ? `${desc} (${count + 1})` : desc;
          })
          .filter((desc) => desc !== null);
        this.selectedSpecId = undefined;

        if (!this.editingItem) {
          this.specInputValue = "";
        } else {
          if (this.specInputValue && this.goodsSpecs.length > 0) {
            const matchedSpec = this.goodsSpecs.find(
              (spec) => spec.desc === this.specInputValue
            );
            if (matchedSpec) {
              this.selectedSpecId = matchedSpec.id;
              // 编辑模式下，如果规格有价格信息，也设置为后台标价（仅用于显示）
              if (
                matchedSpec.price !== undefined &&
                matchedSpec.price !== null
              ) {
                this.formData.pre_discount_price = matchedSpec.price / 100;
              }
            }
          }
        }
      } catch (error) {
        console.error("获取商品规格失败:", error);
        this.$message.error("获取商品规格失败");
        this.goodsSpecs = [];
        this.specDataSource = [];
      }
    },

    // 提取原始规格描述
    extractOriginalDesc(displayText) {
      return displayText.replace(/ \(\d+\)$/, "");
    },

    // 规格输入变化处理
    handleSpecInputChange(value) {
      const originalDesc = this.extractOriginalDesc(value || "");
      this.formData.goods_spec_desc = originalDesc;

      // 手动输入时，寻找匹配的规格
      if (originalDesc) {
        const exactMatch = this.goodsSpecs.find(
          (spec) => spec.desc === originalDesc
        );
        if (exactMatch) {
          this.selectedSpecId = exactMatch.id;
          this.formData.img = exactMatch.img || "";
          if (exactMatch.price !== undefined && exactMatch.price !== null) {
            this.formData.pre_discount_price = exactMatch.price / 100;
          }
          this.uploadKey++;
        } else {
          this.selectedSpecId = undefined;
        }
      } else {
        this.selectedSpecId = undefined;
      }
    },

    // 规格选择处理 - 用户从下拉列表选择时触发
    handleSpecSelect(value, option) {
      const originalDesc = this.extractOriginalDesc(value || "");
      this.formData.goods_spec_desc = originalDesc;

      // 通过原始描述找到对应的规格对象
      const matchedSpecs = this.goodsSpecs.filter(
        (spec) => spec.desc === originalDesc
      );
      if (matchedSpecs.length > 0) {
        // 如果有多个相同描述的规格，根据选择的序号确定具体的规格
        let selectedSpec;
        const numberMatch = value.match(/ \((\d+)\)$/);
        if (numberMatch && matchedSpecs.length > 1) {
          const index = parseInt(numberMatch[1]) - 1;
          selectedSpec = matchedSpecs[index] || matchedSpecs[0];
        } else {
          selectedSpec = matchedSpecs[0];
        }

        this.selectedSpecId = selectedSpec.id;
        this.formData.img = selectedSpec.img || "";
        // 如果规格有价格信息，设置为后台标价
        if (selectedSpec.price !== undefined && selectedSpec.price !== null) {
          this.formData.pre_discount_price = selectedSpec.price / 100;
        }
        this.uploadKey++;
      }
    },

    // 图片上传删除处理
    removeUpload(row) {
      if (row.type === "img") {
        this.formData.img = "";
      }
    },

    // 图片上传结果处理
    resultUpload(row) {
      if (row.type === "img") {
        this.formData.img = row.url;
      }
    },
  },
  beforeDestroy() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },
};
</script>

<style scoped>
.mb16 {
  margin-bottom: 16px;
}
.mt10 {
  margin-top: 10px;
}
.fs12 {
  font-size: 12px;
}
.color666 {
  color: #666;
}
</style> 